var viewer_rtlignore_default = {
  "gallery_container": "lExT5",
  "imageTitleContainer": "bqNnK",
  "clickableItem": "j6J7G",
  "prerender": "aJePV",
  "expandContainer": "IZ69C",
  "expandIcon": "YtdCR",
  "itemOverlay": "_0OPaV",
  "imageTitle": "_2Jb2X",
  "pointer": "fvIAb",
  "fadeIn": "MfX3i",
  "changing_background": "xlBI4"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
